import { Event } from './event'
import { EVENT_TYPE } from './event-type'

/**
 * Creates a shown event.
 * @param {Object} payload - The data associated with the event.
 * @param {string} [payload.name] - The component name
 * @returns {Event} The created shown event.
 */
export function createShownEvent(payload) {
  return new Event(EVENT_TYPE.SHOWN, payload)
}

/**
 * Creates a pressed event.
 * @param {Object} payload - The data associated with the event.
 * @param {string} [payload.name] - The component name
 * @returns {Event} The created pressed event.
 */
export function createPressedEvent(payload) {
  return new Event(EVENT_TYPE.PRESSED, payload)
}

/**
 * Creates a scrolled event.
 * @param {Object} payload - The data associated with the event.
 * @param {string} [payload.name] - The component name
 * @returns {Event} The created scrolled event.
 */
export function createScrolledEvent(payload) {
  return new Event(EVENT_TYPE.SCROLLED, payload)
}
